import { clsx } from 'clsx';

// Cells are padded tighter on small screens so narrow tables fit without scrolling.
// Wider ones still scroll inside the wrapper.
const cellClassName = 'px-2 py-3 sm:p-4';

// Column headers and the first cell of each row (the row header) share styling.
const headerCellClassName = clsx(cellClassName, 'font-semibold text-[#111827]');

export const ComparisonTable = (props: {
  columns: React.ReactNode[];
  rows: React.ReactNode[][];
  className?: string;
}) => {
  return (
    <div
      className={clsx(
        'w-full min-w-0 overflow-x-auto rounded-xl border border-[#e5e7eb]',
        props.className,
      )}
    >
      <table className="w-full border-collapse text-left typography-v1-body4">
        <thead>
          <tr className="border-b border-[#e5e7eb] bg-[#f9fafb]">
            {props.columns.map((column, index) => (
              <th key={index} scope="col" className={headerCellClassName}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.rows.map((row, rowIndex) => (
            <tr key={rowIndex} className="bg-white even:bg-[#f9fafb]">
              {row.map((cell, index) =>
                index === 0 ? (
                  <th key={index} scope="row" className={headerCellClassName}>
                    {cell}
                  </th>
                ) : (
                  <td key={index} className={clsx(cellClassName, 'text-[#374151]')}>
                    {cell}
                  </td>
                ),
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
